import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import type { Locale } from "../lib/types";
import ar from "./locales/ar.json";
import en from "./locales/en.json";

const KEY = "astro.locale";

export const LOCALES: Locale[] = ["ar", "en"];
export const dirOf = (l: Locale): "rtl" | "ltr" => (l === "ar" ? "rtl" : "ltr");

function initialLocale(): Locale {
  try {
    const saved = localStorage.getItem(KEY);
    if (saved === "ar" || saved === "en") return saved;
  } catch {
    /* ignore */
  }
  // Arabic-first product: default to Arabic unless the OS is clearly English-only.
  return typeof navigator !== "undefined" && navigator.language?.toLowerCase().startsWith("en") && !navigator.languages?.some((l) => l.startsWith("ar")) ? "en" : "ar";
}

/** Keeps <html lang dir> in sync so Tailwind logical utilities and native controls flip. */
export function applyDocumentLocale(locale: Locale): void {
  document.documentElement.lang = locale;
  document.documentElement.dir = dirOf(locale);
}

export async function setLocale(locale: Locale): Promise<void> {
  try {
    localStorage.setItem(KEY, locale);
  } catch {
    /* ignore */
  }
  await i18n.changeLanguage(locale);
}

void i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, ar: { translation: ar } },
  lng: initialLocale(),
  fallbackLng: "en",
  interpolation: { escapeValue: false }, // React already escapes
  returnNull: false,
});

if (typeof document !== "undefined") {
  applyDocumentLocale(i18n.language as Locale);
  i18n.on("languageChanged", (l) => applyDocumentLocale(l as Locale));
}

export default i18n;
